export const routes = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Payments",
    link: "/#",

    subRoutes: [
      {
        name: 'PF Payments',
        link: '/main_regular_payments',
      },
      {
        name: '2M2 Payments',
        link: '/main_2m2_payments',
      },
    ]
  },
  {
    name: "Join Us",
    link: "/registration",
  },
   {
    name: "Contact Us",
    link: "/contact",
  },
];
